import { ProcedureUnitTypeRule } from '../../models/unit-type-rules-config';
import { allTeeth, molarTeeth } from '../teeth-sets';
import { UnitTypesInBridge } from '@modules/teeth-diagram/models/unit-type-in-bridge.enum';
import { LimitedFeatures } from '@shared/models/limited-features';
import { SoftwareOptions } from '@shared/models/enums/enums';
import { procedureMapComposites } from '../../models/procedure-map-composites';

export const rulesForBridgeFixedRestorative: ProcedureUnitTypeRule = {
	ProcedureMaps: [procedureMapComposites.fixedRestorativeAll],
	TeethRules: [
		{
			Ids: allTeeth,
			UnitAndMaterialRules: {
				UnitTypeRules: [
					{
						Id: UnitTypesInBridge.Abutment
					},
					{
						Id: UnitTypesInBridge.Pontic
					},
					{
						Id: UnitTypesInBridge.Maryland
					},
					{
						Id: UnitTypesInBridge.ImplantBased
					},
					{
						Id: UnitTypesInBridge.Missing
					},
					{
						Id: UnitTypesInBridge.EggshellBridge,
						RestrictionUnitTypes: {
							LimitedFeatures: LimitedFeatures.EggshellCrown
						}
					},
					{
						Id: UnitTypesInBridge.MockupBridge,
						RestrictionUnitTypes: {
							LimitedFeatures: LimitedFeatures.MockupTooth,
							SoftwareOptions: [SoftwareOptions.EnableMockUpIndication]
						}
					}
				]
			}
		},
		{
			Ids: molarTeeth,
			UnitAndMaterialRules: {
				UnitTypeRules: [
					{
						Id: UnitTypesInBridge.Inlay
					},
					{
						Id: UnitTypesInBridge.Onlay
					}
				]
			}
		}
	]
};
